import PropTypes from 'prop-types';
import { object } from 'yup';
import {
  MY_FORM_FIELD_IMAGE,
  MY_FORM_FIELD_IMAGE_MULTIPLE,
  MY_FORM_FIELD_TEXT,
  MY_FORM_FIELD_HTML,
  MY_FORM_FIELD_DATE,
  MY_FORM_FIELD_SELECT,
  MY_FORM_FIELD_SELECT_MULTIPLE,
  MY_FORM_FIELD_SELECT_AUTOCOMPLETE,
  MY_FORM_FIELD_TIME,
  MY_FORM_FIELD_COORDINATE,
} from '../../form/form-constants';

// table columns
export const crudTableColumnPropTypes = PropTypes.shape({
  field: PropTypes.string.isRequired,

  titleId: PropTypes.string,
  isMobile: PropTypes.bool,
  render: PropTypes.func,
  sorting: PropTypes.bool,
});
export const defaultCrudTableColumnPropTypes = PropTypes.shape({
  titleId: undefined,
  isMobile: false,
  render: undefined,
  sorting: true,
});

export const crudTableColumnsPropTypes = PropTypes.arrayOf(
  crudTableColumnPropTypes,
);

// fields
export const crudFormFieldInputPropsPropTypes = PropTypes.shape({
  autoFocus: PropTypes.bool,
  type: PropTypes.string,
  multiline: PropTypes.bool,
});
export const defaultCrudFormFieldInputPropsPropTypes = PropTypes.shape({
  autoFocus: undefined,
  type: undefined,
  multiline: undefined,
});

export const crudFormFieldPropTypes = PropTypes.shape({
  type: PropTypes.oneOf([
    MY_FORM_FIELD_IMAGE,
    MY_FORM_FIELD_IMAGE_MULTIPLE,
    MY_FORM_FIELD_TEXT,
    MY_FORM_FIELD_HTML,
    MY_FORM_FIELD_DATE,
    MY_FORM_FIELD_TIME,
    MY_FORM_FIELD_SELECT,
    MY_FORM_FIELD_SELECT_MULTIPLE,
    MY_FORM_FIELD_SELECT_AUTOCOMPLETE,
    MY_FORM_FIELD_COORDINATE,
  ]),
  name: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  inputProps: crudFormFieldInputPropsPropTypes,
});
export const defaultCrudFormFieldPropTypes = PropTypes.shape({
  inputProps: defaultCrudFormFieldInputPropsPropTypes,
});

export const crudFormFieldsPropTypes = PropTypes.arrayOf(
  crudFormFieldPropTypes,
);

// validation schema
export const crudFormValidationSchemaPropTypes = PropTypes.instanceOf(object);


// routes
export const crudRouteSingleInitPropTypes = PropTypes.shape({
  load: PropTypes.func.isRequired,
  onLoadSuccess: PropTypes.func.isRequired,
  setFormFields: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shouldShowSuccessSnackbar: PropTypes.bool,
  setIsLoadingFalseOnSuccess: PropTypes.bool,
  setIsLoadingTrueOnStart: PropTypes.bool,
});
export const defaultCrudRouteSingleInitPropTypes = PropTypes.shape({
  successMessage: undefined,
  errorMessage: undefined,
  shouldShowSuccessSnackbar: true,
  setIsLoadingFalseOnSuccess: true,
  setIsLoadingTrueOnStart: true,
});
export const crudRouteInitPropTypes = PropTypes.arrayOf(
  crudRouteSingleInitPropTypes,
);
export const defaultCrudRouteInitPropTypes = [];

// export const crudRouteOptionsPropTypes = PropTypes.shape({
//   index: PropTypes.bool,
//   create: PropTypes.bool,
//   detail: PropTypes.bool,
//   edit: PropTypes.bool,
//   delete: PropTypes.bool,
// });
// export const defaultCrudRouteOptionsPropTypes = {
//   index: true,
//   create: true,
//   detail: true,
//   edit: true,
//   delete: true,
// };

export const crudDeleteOptionsPropTypes = PropTypes.shape({
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  thumb: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
});
export const defaultCrudDeleteOptionsPropTypes = {
  title: undefined,
  subtitle: undefined,
  thumb: undefined,
};

export const crudRouteIndexLabelIdsPropTypes = PropTypes.shape({
  errorLoad: PropTypes.string.isRequired,
  errorDelete: PropTypes.string.isRequired,
  successDelete: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
});

export const crudRouteIndexTabPropTypes = PropTypes.shape({
  getAll: PropTypes.func.isRequired,
  labelIds: PropTypes.shape({
    tab: PropTypes.string.isRequired,
    'mt-title': PropTypes.string.isRequired,
  }).isRequired,
});
export const crudRouteIndexTabsPropTypes = PropTypes.arrayOf(
  crudRouteIndexTabPropTypes,
);
export const defaultCrudRouteIndexTabsPropTypes = [];

export const crudRouteIndexComponentPropsPropTypes = PropTypes.shape({
  tableColumns: crudTableColumnsPropTypes.isRequired,
  Repository: PropTypes.func.isRequired,
  labelIds: crudRouteIndexLabelIdsPropTypes.isRequired,
  DetailDialog: PropTypes.element,
  iseUseTab: PropTypes.bool,
  tabs: crudRouteIndexTabsPropTypes,
  init: crudRouteInitPropTypes,
});
export const defaultCrudRouteIndexComponentPropsPropTypes = PropTypes.shape({
  DetailDialog: undefined,
  iseUseTab: false,
  tabs: defaultCrudRouteIndexTabsPropTypes,
  init: defaultCrudRouteInitPropTypes,
});

export const crudRoutePropTypes = PropTypes.shape({
  path: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  exact: PropTypes.bool.isRequired,
  private: PropTypes.bool.isRequired,
  componentProps: PropTypes.oneOfType([
    crudRouteIndexComponentPropsPropTypes,
  ]),
});
export const crudRoutesPropTypes = PropTypes.shape({
  index: crudRoutePropTypes,
  create: crudRoutePropTypes,
  edit: crudRoutePropTypes,
});
export const defaultCrudRoutesPropTypes = PropTypes.shape({
  index: undefined,
  create: undefined,
  edit: undefined,
});
